import React from 'react';
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from '@shared-ui/viewport-context';

import { DealLoadingCardsProps } from '../../hotel-module-types';
import { GridPlaceholder } from './grid-placeholder';

export const DealLoadingCards = (props: DealLoadingCardsProps) => {
  const {
    view: { view },
    desktopLoadingCards = 3,
  } = props;

  const loadingCard = (desktopLoadingCardsDetails: number) => {
    return (
      <Viewport>
        <ViewSmall>
          <GridPlaceholder templateComponentId={'GridPlaceholder'} loadingCards={1} />
        </ViewSmall>
        <ViewMedium>
          <GridPlaceholder templateComponentId={'GridPlaceholder'} loadingCards={2} />
        </ViewMedium>
        <ViewLarge>
          <GridPlaceholder templateComponentId={'GridPlaceholder'} loadingCards={desktopLoadingCardsDetails} />
        </ViewLarge>
      </Viewport>
    );
  };

  return (
    <>
      {(() => {
        switch (view) {
          case 'grid':
          case 'concierge-slider':
          case 'media-slider':
          case 'slick-slider':
            return <>{loadingCard(desktopLoadingCards)}</>;
          default:
            return <></>;
        }
      })()}
    </>
  );
};
